import { render, staticRenderFns } from "./reactionManage.vue?vue&type=template&id=ddacbb40&scoped=true&"
import script from "./reactionManage.vue?vue&type=script&lang=js&"
export * from "./reactionManage.vue?vue&type=script&lang=js&"
import style0 from "./reactionManage.vue?vue&type=style&index=0&id=ddacbb40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddacbb40",
  null
  
)

export default component.exports